import { render, staticRenderFns } from "./BadgeGroup.vue?vue&type=template&id=63eb3f3d&"
import script from "./BadgeGroup.vue?vue&type=script&lang=js&"
export * from "./BadgeGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports